// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","madeby":"Footer_madeby__EEbqf","links":"Footer_links__wMgLO"};